var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-switch",on:{"click":function($event){return _vm.$emit('change', !_vm.value)}}},[(_vm.value)?_c('img',{attrs:{"src":require("@/assets/mall/img_switch_on.svg"),"alt":"켜짐"}}):_c('img',{attrs:{"src":require("@/assets/mall/img_switch_off.svg"),"alt":"꺼짐"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd4b3242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/atoms/MallSwitch.vue
// module id = null
// module chunks = 